<template>
  <div id="mapMenu" :style="{ zoom: zoom + '%' }">
    <ul>
      <li
        @click="clickMenu(item, index)"
        v-for="(item, index) in items"
        :key="index"
        :class="{ active: item.isActive }"
      >
        <Icon :type="item.icon" />
        <h3>{{ item.num }}</h3>
        <label>{{ index }}</label>
      </li>
      <!-- 
      <li>
        <Icon type="md-bus" />
        <h3>{{ xisaoNum }}</h3>
        <label>洗扫车两</label>
      </li>
      <li>
        <Icon type="md-car" />
        <h3>{{ qingyunNum }}</h3>
        <label>清运车辆</label>
      </li>
      <li>
        <Icon type="md-person" />
        <h3>{{ personsNum }}</h3>
        <label>人员分布</label>
      </li> -->
    </ul>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["zoom"],
  data() {
    return {
      items: {
        /* 巡查点: {
          isActive: true,
          num: 0,
          icon: "md-pin",
        }, */
        作业线路: {
          isActive: true,
          num: 0,
          icon: "ios-pulse",
        },
        作业车辆: {
          isActive: true,
          num: 0,
          icon: "md-bus",
        },

        作业人员: {
          isActive: true,
          num: 0,
          icon: "md-person",
        },
      },
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        returnCoord: 2,
        startTime: "",
      },
    };
  },
  methods: {
    getLine12() {
      this.items["作业线路"].num = data.length;
      var data123 = [
        {
          pointList: [
            [
              { x: 113.14, y: 23.24 },
              { x: 113.13, y: 23.22 },
            ],
          ],
        },
        {
          pointList: [
            { x: 113.14, y: 23.24 },
            { x: 113.13, y: 23.22 },
          ],
        },
      ];
      this.lines = data123;
      return;
      axios({
        method: "post",
        url: axios.mwm + "/line/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.items["作业线路"].num = data.length;
        this.lines = data;
        var data123 = [
          {
            pointList: [
              [
                { x: 113.14, y: 23.24 },
                { x: 113.13, y: 23.22 },
              ],
            ],
          },
          {
            pointList: [
              { x: 113.14, y: 23.24 },
              { x: 113.13, y: 23.22 },
            ],
          },
        ];
        //this.showline(data);
      });
    },
    getPersons() {
      axios({
        method: "post",
        url: axios.lbs + "/locate/getLocate",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        this.persons = data.length;
        this.per = [];
        this.qingyun = [];
        this.xisao = [];
        for (const i in data) {
          if (data[i].active) {
            if (data[i].deviceUseType == 1) {
              /* if (data[i].carTypeName.indexOf("扫") != -1) {
                this.xisao.push(data[i]);
              } else if (data[i].carTypeName.indexOf("巡查") != -1) {
                this.qingyun.push(data[i]);
              } */
              this.xisao.push(data[i]);
            } else {
              this.per.push(data[i]);
            }
          }
        }
        this.items["作业人员"].num = this.per.length;
        this.ddddd(this.items["作业人员"], this.per, "作业人员");
        this.items["作业车辆"].num = this.xisao.length;
        this.ddddd(this.items["作业车辆"], this.xisao, "作业车辆");
        //this.items["巡查车辆"].num = this.qingyun.length;
        //this.ddddd(this.items["巡查车辆"], this.qingyun, "巡查车辆");
        return;
        for (const i in data) {
          var aaa = data[i].deviceUseType;
          if (data[i].active) {
            data[i].select = false;
            data[i].show = true;
            data[i].name =
              aaa == null
                ? data[i].deviceNo
                : aaa == 1
                ? data[i].carNo
                : data[i].personName;
            data[i].service =
              data[i].service == null
                ? { name: "暂无", status: "未排班" }
                : JSON.parse(data[i].service);
            data[i].serviceName = data[i].service.name;
            data[i].serviceStatus = data[i].service.status;
            data[i].icon =
              aaa == null ? "arrow" : aaa == 1 ? data[i].carTypeIcon : "person";
            data[i].locateLng = data[i].x;
            data[i].locateLat = data[i].y;
            data[i].realTimeStatus =
              aaa == 1
                ? data[i].deviceStatus
                : data[i].deviceStatus == 1
                ? 1
                : 7;
            data[i].accStatus = this.$t("accStatus." + data[i].accStatus);
            data[i].flag = this.$t("flag." + data[i].flag);
            data[i].gpsTime = this.utils.time(data[i].gpsTime);
            data[i].alarmList =
              data[i].alarmList.length > 0
                ? data[i].alarmList.join(",")
                : "暂无报警";
            myStoreData.push(data[i]);
            if (data[i].realTimeStatus == 1) {
              this.offLineLength += 1;
            } else {
              this.onLineLength += 1;
            }
          } else {
            this.noOnline.push(data[i]);
          }
        }

        //this.tabs(this.tabValue);
      });
    },
    getwangge() {
      return;
      axios({
        method: "post",
        url: axios.swm + "/grid/list",
        data: {},
      }).then((res) => {
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.wangge = data;
        this.items["作业网格"].num = data.length;
        //this.showwangge(data);
      });
      var d = [
        {
          regionList: [
            [
              { x: 113.12, y: 23.22 },
              { x: 113.11, y: 23.23 },
              { x: 113.1, y: 23.21 },
              { x: 113.1, y: 23.19 },
            ],
          ],
        },
      ];
    },
    getLine() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/list",
        data: this.searchItem,
      }).then((res) => {
        //console.log(res);
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        var lineIdList = [];
        for (let i = 0; i < data.length; i++) {
          lineIdList.push(data[i].id);
        }
        this.getLinesDetail(lineIdList);
        this.items["作业线路"].num = data.length;
      });
    },
    getLinesDetail(v) {
      if (v.length == 0) {
        this.linesData = [];
        this.ddddd(this.items["作业线路"], this.linesData, "作业线路");
        return;
      }
      var aa = [];

      for (const i in v) {
        this.utils.loading(this, "加载中");
        axios({
          method: "post",
          url: axios.rule + "/route/item",
          data: { id: v[i] },
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          var data = res.data.data.coordList;
          var bbb = {
            name:res.data.data.name,
            pointList: data,
          };
          aa.push(bbb);

          if (i == v.length - 1) {
            this.linesData = aa;

            this.ddddd(this.items["作业线路"], this.linesData, "作业线路");
          }
        });
      }
    },
    getSiteCollect() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/siteCollect/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        
        //var data = [{ name: "11111" }];
        this.ljt = data;
        this.items["巡查点"].num = data.length;
        this.ddddd(this.items["巡查点"], this.ljt, "巡查点");
      });
    },
    clickMenu(item, index) {
      item.isActive = !item.isActive;
      if (index == "巡查点") {
        this.ddddd(item, this.ljt, index);
      } else if (index == "作业车辆") {
        this.ddddd(item, this.xisao, index);
      } else if (index == "巡查车辆") {
        this.ddddd(item, this.qingyun, index);
      } else if (index == "作业网格") {
        this.ddddd(item, this.wangge, index);
      } else if (index == "作业人员") {
        this.ddddd(item, this.per, index);
      } else if (index == "作业线路") {
        this.ddddd(item, this.linesData, index);
      }
    },
    ddddd(item, data, index) {
      if (item.isActive) {
        this.$emit("mapData", data, index);
      } else {
        this.$emit("mapData", [], index);
      }
    },
    groups(v) {
      this.searchItem.groupIdList = [];
      for (let i = 0; i < v.length; i++) {
        this.searchItem.groupIdList.push(v[i].id);
      }
      this.getSiteCollect();
      this.getPersons();
      //this.getwangge();
      this.getLine();
    },
  },
  mounted() {
    //this.setheight();
  },
};
</script>
<style>
#mapMenu {
  position: absolute;

  z-index: 2;
  width: 76px;
  height: calc(100% - 0px);
  right: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.7);
  border-left: 2px solid #1659d4;

  text-align: center;
  padding-top: 30px;
}
#mapMenu h3 {
  font-weight: bold;
  font-size: 24px;
  margin-top: 4px;
  margin-bottom: 4px;
  color: #fff;
}
#mapMenu li {
  padding: 0px 10px;
  margin-bottom: 15px;
  margin-top: 15px;
}
#mapMenu li:hover,
#mapMenu li.active {
  border-left: 2px #36b7e2 solid;
  cursor: pointer;
}

#mapMenu label {
  opacity: 0.5;
}
#mapMenu i {
  font-size: 30px;
  color: #45aeeb;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/mapMenu.vue